import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SearchCoordinatesPayload, LocationCoordinate, SearchLocation } from 'src/app/state-management';
import { ContactDB } from 'src/app/models/problem';
import { SearchItemType, SearchItem, DnvMapInfo } from 'dnv-lib';
import { environment } from 'src/environments/environment';


@Injectable()
export class LocationService {
  gisUrl = 'api/gis/';

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getLocationCoordinates(location: SearchCoordinatesPayload): Observable<LocationCoordinate> {
    // console.log(location);
    switch (location.type) {
      case SearchItemType.Address:
        return this.httpClient.get<any>(this.gisUrl + 'CivicAddress/' + location.name, this.httpOptions);
      case SearchItemType.StreetName:

        break;
      case SearchItemType.Park:
        return this.httpClient.get<LocationCoordinate>(
          // 'https://webservices.dnvwebstage.cdnv.dnv.ca/dnv_search/api/geoinfo/street/W%20QUEENS%20RD',
          this.gisUrl + 'Park/' + location.name,
          this.httpOptions
        );
      case SearchItemType.Intersection:
        return this.httpClient.get<LocationCoordinate>(
          // 'https://webservices.dnvwebstage.cdnv.dnv.ca/dnv_search/api/geoinfo/street/W%20QUEENS%20RD',
          this.gisUrl + 'Intersections/' + location.name,
          this.httpOptions
        );

      default:
        return throwError('Unexpected type ' + location.type);
    }
  }

  getStreetGeometry(location: SearchCoordinatesPayload): Observable<LocationCoordinate> {
    return this.httpClient.get<LocationCoordinate>(
      'api/gis/geoinfostreet/' + location.name,
      this.httpOptions
    );
  }

  getLocationFromCoordinates(token: string, mapInfo: DnvMapInfo): Observable<SearchLocation[]> {
    return this.httpClient.post<any>(this.gisUrl + token, mapInfo, this.httpOptions);
  }

  getParcelOwner(ltopid: string): Observable<ContactDB[]> {
    return this.httpClient.get<any>(this.gisUrl + 'Owner/' + ltopid, this.httpOptions);
  }

  getParcelOwnerByAddress(address: string): Observable<ContactDB[]> {
    return this.httpClient.get<any>(this.gisUrl + 'OwnerByAddress/' + address, this.httpOptions);
  }

  // Local version of dnv-lib DnvSearchService getSearchItems (dnv-search.service.ts) that let the caller handle errors
  getSearchItems(url: string): Observable<SearchItem[]> {
    return this.httpClient.get<SearchItem[]>(url);
  }

  getPermitItems(url: string): Observable<string[]> {
    return this.httpClient.get<string[]>(url);
  }

}
